import '@/assets/style/main.scss';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createApp } from 'vue';
import App from './App.vue';
import i18n from './i18n';
import router from './router/router';
import { entraAuthService } from './services/auth/entra-auth-service';
import { fortnoxAuthService } from './services/auth/fortnox-auth-service';

async function mountApp() {
  await entraAuthService.initialize();

  const app = createApp(App);

  app.use(router);
  app.use(i18n);
  app.use(VueQueryPlugin);

  app.mount('#app');

  await fortnoxAuthService.handleRedirect(); // Handle redirect after Fortnox login
}

mountApp();
